import { Theme } from '../styled';

export default {
  color: {
    primary: '#5cb85c',
  },
} as Theme;
